export default "__VITE_ASSET__d1ca5e78__"